import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgxValidationMessageComponent } from './validation-message/validation-message.component';
import {
  NgxFilterByNumberComponent,
} from './custom-smart-table-components/filter-by-number/filter-by-number.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ThemeModule } from '../shared/theme.module';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { FileUploadModule } from '@iplab/ngx-file-upload';
import { FileUploadDetailListComponent } from './file-upload-detail-list/file-upload-detail-list.component';
import { FileUploadDetailDialogComponent } from './file-upload-detail-dialog/file-upload-detail-dialog.component';
import { ProcedureStepperUploadListComponent } from './procedure-stepper-upload-list/procedure-stepper-upload-list.component';
import { ProcedureStepperUploadDialogComponent } from './procedure-stepper-upload-dialog/procedure-stepper-upload-dialog.component';


const COMPONENTS = [
  NgxValidationMessageComponent,
  NgxFilterByNumberComponent,
  LoadingSpinnerComponent
];

@NgModule({
    imports: [
        ReactiveFormsModule,
        FormsModule,
        CommonModule,
        ThemeModule,
        FileUploadModule
    ],
    exports: [...COMPONENTS],
    declarations: [...COMPONENTS, ConfirmDialogComponent, LoadingSpinnerComponent, FileUploadDetailListComponent, FileUploadDetailDialogComponent, ProcedureStepperUploadListComponent, ProcedureStepperUploadDialogComponent]
})
export class ComponentsModule {
}
